import { getCookie } from "@insite/client-framework/Common/Cookies";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import * as React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

const enum fields {
    variant = "variant",
    label = "label",
    link = "link",
    alignment = "alignment",
    customCSS = "customCSS",
    controls = "controls",
    formBuilderBaseUrl = "formBuilderBaseUrl",
    userNameDataId = "userNameDataId",
    billToCustomerNumberDataId = "billT0CustomerNumberDataId",
    productPartNumberDataId = "productPartNumberDataId",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.variant]: "primary" | "secondary" | "tertiary";
        [fields.label]: string;
        [fields.link]: LinkFieldValue;
        [fields.alignment]: string;
        [fields.customCSS]: string;
        [fields.formBuilderBaseUrl]: string;
        [fields.userNameDataId]: string;
        [fields.billToCustomerNumberDataId]: string;
        [fields.productPartNumberDataId]: string;
    };
}

type Props = HasProduct & ReturnType<typeof mapStateToProps> & OwnProps;

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => ({
});

export interface ProductDetailsFeedbackButtonStyles {
    button?: ButtonPresentationProps;
}

export const feedbackButtonStyles: ProductDetailsFeedbackButtonStyles = {
    button: {
        css: css`
            width: 100%;
        `,
    },
};

const currentUserName = getCookie("currentUserUserName");
const currentBillToNumber = getCookie("currentBillToNumber");
const onClickHandler = (productPartNumber: string, baseUrl: string) => {

    let feedbackLinkParams = "";

    if (currentUserName && currentUserName !== undefined && currentUserName !== "") {
        feedbackLinkParams = `${feedbackLinkParams}&control109799959=${currentUserName}`;
    }
    if (currentBillToNumber && currentBillToNumber !== undefined && currentBillToNumber !== "") {
        feedbackLinkParams = `${feedbackLinkParams}&control109799975=${currentBillToNumber}`;
    }
    if (productPartNumber && productPartNumber !== undefined && productPartNumber !== "") {
        feedbackLinkParams = `${feedbackLinkParams}&control109799903=${productPartNumber}`;
    }

    window.open(`${baseUrl}${feedbackLinkParams}`,"_blank");
}

const ProductDetailsFeedbackButton = ({
    product: {
        productNumber
    },
    fields,
}: Props) => {
    return (
        <ContentWrapper alignment={fields.alignment} className="wrapper">
            <Button variant={fields.variant} onClick={() => { onClickHandler(productNumber, fields.formBuilderBaseUrl) }} className="button">
                {fields.label}
            </Button>
        </ContentWrapper >
    );
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsFeedbackButton)),
    definition: {
        displayName: "Feedback Button",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.variant,
                displayName: "Button Variant",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Primary", value: "primary" },
                    { displayName: "Secondary", value: "secondary" },
                    { displayName: "Tertiary", value: "tertiary" },
                ],
                defaultValue: "tertiary",
                fieldType: "General",
                tab: basicTab,
            },
            {
                name: fields.alignment,
                displayName: "Button Alignment",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Left", value: "flex-start" },
                    { displayName: "Center", value: "center" },
                    { displayName: "Right", value: "flex-end" },
                ],
                defaultValue: "center",
                fieldType: "General",
                tab: basicTab,
            },
            {
                name: fields.label,
                displayName: "Button Label",
                editorTemplate: "TextField",
                defaultValue: "Feedback",
                fieldType: "Translatable",
                tab: basicTab,
            },
            {
                name: fields.formBuilderBaseUrl,
                displayName: "Form Builder Base Url",
                defaultValue: "https://form.123formbuilder.com/6492241/auer-steel-web-feedback-form",
                fieldType: "General",
                editorTemplate: "TextField",
            },
        ]
    },
};

export const ContentWrapper = styled.div<InjectableCss & { alignment: string }>`
    display: flex;
    width: 100%;
    justify-content: ${props => props.alignment ?? "flex-start"};
    ${injectCss};
`;

export default widgetModule;
